<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
    top
  >
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <v-card style="background-color: #f9f9f9">
      <v-card-actions style="background-color: #f9f9f9">
        <v-text-field
          v-model="heightValue"
          class="caption"
          type="number"
          suffix="px"
          label="高さ"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-text-field
          v-model="widthValue"
          class="caption"
          type="number"
          suffix="px"
          label="横幅"
          outlined
          hide-details
          dense
        ></v-text-field>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'EditSizeMenu',
  props: {
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    heightValue: {
      get () {
        return this.height
      },
      set (value) {
        this.$emit('update-height', value)
      }
    },
    widthValue: {
      get () {
        return this.width
      },
      set (value) {
        this.$emit('update-width', value)
      }
    }
  }
}
</script>
